import React, { useState, useEffect, useRef } from 'react';
import { 
  Send, Menu, Trash2, Edit2, X, Settings, 
  Mail, Chrome, Apple, LogOut, Star, Check, Shield, Globe, Lock, Palette, Zap, User
} from 'lucide-react';
import { initializeApp } from "firebase/app";
import { 
  getAuth, onAuthStateChanged, signInWithPopup, GoogleAuthProvider, 
  createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut 
} from "firebase/auth";
import { getFirestore, doc, onSnapshot, updateDoc, setDoc } from "firebase/firestore";

// --- Firebase Config (بيانات يوسف البلوشي) ---
const firebaseConfig = {
  apiKey: "AIzaSyA5LHeggY9fWrsLZlnrMhMTKEGSKAzGoDI",
  authDomain: "vaickons-nexus.firebaseapp.com",
  projectId: "vaickons-nexus",
  storageBucket: "vaickons-nexus.firebasestorage.app",
  messagingSenderId: "957542256930",
  appId: "1:957542256930:web:2f4e8c2dec6997545e157b"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const GROQ_KEY = "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";

const languages = ["العربية", "English", "中文", "Español", "Français", "Deutsch", "हिندي", "日本語", "Türkçe", "Русский"];

export default function App() {
  const [user, setUser] = useState(null);
  const [isGuest, setIsGuest] = useState(false);
  const [authEmail, setAuthEmail] = useState('');
  const [authPass, setAuthPass] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [activeTab, setActiveTab] = useState('عام');
  const [chats, setChats] = useState([]);
  const [activeChatId, setActiveChatId] = useState(null);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);

  // إعدادات الخط والشكل الفخم
  const [themeColor, setThemeColor] = useState('#00ffff');
  const [fontSize, setFontSize] = useState(1.5); // خط كبير وواضح جداً
  const [selectedLang, setSelectedLang] = useState('العربية');
  const [showStars, setShowStars] = useState(true);

  const canvasRef = useRef(null);

  useEffect(() => {
    onAuthStateChanged(auth, (u) => { if (u) setUser(u); });
  }, []);

  // أنيميشن النجوم المتحركة
  useEffect(() => {
    if (!showStars || !canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let stars = [];
    const resize = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
    window.addEventListener('resize', resize); resize();
    for(let i=0; i<150; i++) stars.push({x: Math.random()*canvas.width, y: Math.random()*canvas.height, s: Math.random()*2});
    let animationFrame;
    const anim = () => {
      ctx.clearRect(0,0,canvas.width, canvas.height); ctx.fillStyle = themeColor;
      stars.forEach(s => { ctx.beginPath(); ctx.arc(s.x, s.y, s.s, 0, Math.PI*2); ctx.fill(); s.y += 0.5; if(s.y > canvas.height) s.y=0; });
      animationFrame = requestAnimationFrame(anim);
    };
    anim();
    return () => cancelAnimationFrame(animationFrame);
  }, [themeColor, showStars, user, isGuest]);

  const handleAuth = async () => {
    try {
      if(isSignUp) await createUserWithEmailAndPassword(auth, authEmail, authPass);
      else await signInWithEmailAndPassword(auth, authEmail, authPass);
    } catch (e) { alert("خطأ في الدخول: " + e.message); }
  };

  const handleLogout = () => {
    signOut(auth);
    setUser(null);
    setIsGuest(false);
  };

  const handleSend = async () => {
    if (!input.trim() || loading) return;
    setLoading(true);
    const userMsg = input; setInput('');
    let currentId = activeChatId || Date.now();
    let updatedChats = [...chats];
    if (!activeChatId) {
      updatedChats = [{ id: currentId, name: userMsg.substring(0, 15), messages: [] }, ...chats];
      setActiveChatId(currentId);
    }
    const idx = updatedChats.findIndex(c => c.id === currentId);
    updatedChats[idx].messages.push({ role: 'user', content: userMsg });
    setChats([...updatedChats]);

    try {
      const res = await fetch("https://api.groq.com/openai/v1/chat/completions", {
        method: "POST",
        headers: { "Authorization": `Bearer ${GROQ_KEY}`, "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "llama-3.3-70b-versatile",
          messages: [{ role: "system", content: "أنت VAICKONS AI. مطورك يوسف محمد البلوشي." }, { role: "user", content: userMsg }]
        })
      });
      const data = await res.json();
      updatedChats[idx].messages.push({ role: 'assistant', content: data.choices[0].message.content });
      setChats([...updatedChats]);
    } catch { alert("خطأ في الاتصال"); } finally { setLoading(false); }
  };

  if (!user && !isGuest) {
    return (
      <div style={{ height: '100vh', background: '#000', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 20 }}>
        <div style={{ width: '100%', maxWidth: '450px', background: '#080808', padding: '50px 40px', borderRadius: 30, border: '1px solid #111', textAlign: 'center', boxShadow: `0 0 50px ${themeColor}15` }}>
          <h1 style={{ color: themeColor, fontSize: '3.5rem', fontWeight: 900, marginBottom: 10, letterSpacing: '-2px' }}>VAICKONS</h1>
          <p style={{ opacity: 0.5, marginBottom: 40, fontSize: '1rem' }}>بواسطة المطور يوسف محمد البلوشي</p>
          <input placeholder="البريد الإلكتروني" onChange={e=>setAuthEmail(e.target.value)} style={{ width:'100%', padding:15, marginBottom:12, borderRadius:15, background:'#111', color:'#fff', border:'1px solid #222', fontSize: '1.1rem' }} />
          <input type="password" placeholder="كلمة المرور" onChange={e=>setAuthPass(e.target.value)} style={{ width:'100%', padding:15, marginBottom:25, borderRadius:15, background:'#111', color:'#fff', border:'1px solid #222', fontSize: '1.1rem' }} />
          <button onClick={handleAuth} style={{ width:'100%', padding:18, background:themeColor, color:'#000', fontWeight:900, borderRadius:15, border:'none', marginBottom:20, fontSize: '1.2rem', cursor:'pointer', transition: '0.3s' }}>{isSignUp ? 'إنشاء حساب جديد' : 'تسجيل الدخول'}</button>
          <div style={{ display:'flex', gap:15, justifyContent:'center', marginBottom:25 }}>
            <button onClick={()=>signInWithPopup(auth, new GoogleAuthProvider())} style={{ flex: 1, padding:12, background:'#111', borderRadius:12, border:'1px solid #222', color:'#fff', cursor:'pointer' }}><Chrome size={24} style={{margin:'0 auto'}}/></button>
            <button style={{ flex: 1, padding:12, background:'#111', borderRadius:12, border:'1px solid #222', color:'#fff', cursor:'pointer' }}><Apple size={24} style={{margin:'0 auto'}}/></button>
          </div>
          <p onClick={()=>setIsSignUp(!isSignUp)} style={{ color:themeColor, cursor:'pointer', fontWeight: 'bold' }}>{isSignUp ? 'لديك حساب؟ ادخل من هنا' : 'سجل حساب جديد الآن'}</p>
          <button onClick={()=>setIsGuest(true)} style={{ marginTop:30, opacity:0.3, background:'none', border:'none', color:'#fff', cursor:'pointer', fontSize: '0.9rem' }}>الدخول كضيف (بدون حفظ)</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', height: '100vh', background: '#000', color: '#fff', overflow: 'hidden', fontSize: `${fontSize}rem`, fontWeight: 500 }}>
      <canvas ref={canvasRef} style={{position:'fixed', inset:0, zIndex:0, opacity:0.4, pointerEvents:'none'}} />
      
      {sidebarOpen && <div onClick={()=>setSidebarOpen(false)} style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', zIndex:999}} />}

      <aside style={{ width: sidebarOpen ? '320px' : '0', background: '#050505', transition: '0.4s cubic-bezier(0.4, 0, 0.2, 1)', position: 'fixed', height: '100%', zIndex: 1000, overflow: 'hidden', borderRight: '1px solid #111' }}>
        <div style={{ width: '320px', padding: '30px', display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 40 }}>
             <h2 style={{ color: themeColor, fontWeight: 900, fontSize: '1.8rem' }}>VAICKONS</h2>
             <X onClick={()=>setSidebarOpen(false)} cursor="pointer" size={28}/>
          </div>
          <button onClick={()=>{setActiveChatId(null); setSidebarOpen(false);}} style={{ width:'100%', padding:15, background:'#111', border:`1px solid ${themeColor}`, borderRadius:15, color:'#fff', fontWeight: 900, marginBottom:30, cursor:'pointer' }}>+ دردشة جديدة</button>
          <div style={{ flex:1, overflowY:'auto' }}>
            {chats.map(c => (
              <div key={c.id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:15, borderRadius:15, background: activeChatId===c.id?'#151515':'transparent', marginBottom:10, border: activeChatId===c.id?`1px solid #222` : '1px solid transparent' }}>
                <span onClick={()=>{setActiveChatId(c.id); setSidebarOpen(false);}} style={{cursor:'pointer', flex:1, fontWeight: 'bold'}}>{c.name}</span>
                <div style={{display:'flex', gap:12}}>
                  <Edit2 size={16} onClick={()=>setChats(chats.map(ch=>ch.id===c.id?{...ch, name:prompt("تغيير الاسم:")||ch.name}:ch))} cursor="pointer" color="#555"/>
                  <Trash2 size={16} onClick={()=>setChats(chats.filter(ch=>ch.id!==c.id))} cursor="pointer" color="#ff4444"/>
                </div>
              </div>
            ))}
          </div>
          <div onClick={handleLogout} style={{ marginTop: 20, padding: 15, borderRadius: 15, background: '#111', color:'#ff4444', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:10, fontWeight: 900, border: '1px solid #311' }}>
            <LogOut size={22}/> تسجيل الخروج
          </div>
        </div>
      </aside>

      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', zIndex: 1, width: '100%' }}>
        <header style={{ padding: '20px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #111', background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(10px)' }}>
          <Menu onClick={()=>setSidebarOpen(true)} cursor="pointer" color={themeColor} size={35} />
          <h1 style={{ fontWeight: 900, fontSize: '1.5rem', letterSpacing: '-1px' }}>VAICKONS AI</h1>
          <Settings onClick={()=>setShowSettings(true)} cursor="pointer" color="#444" size={30} />
        </header>

        <div style={{ flex: 1, overflowY: 'auto', padding: '30px' }}>
          <div style={{maxWidth:'900px', margin:'0 auto'}}>
            {activeChatId ? chats.find(c=>c.id===activeChatId).messages.map((m,i)=>(
              <div key={i} style={{ marginBottom:40, textAlign: m.role==='user'?'right':'left' }}>
                <div style={{ display:'inline-block', padding: '20px 25px', borderRadius:25, background: m.role==='user'?'#0a0a0a':'transparent', border: m.role==='user'?'1px solid #222':'none', maxWidth:'85%', lineHeight: '1.6', fontSize: '1.4rem' }}>
                    {m.content}
                </div>
              </div>
            )) : (
              <div style={{ textAlign:'center', marginTop:'20vh' }}>
                <h1 style={{ fontSize: '4rem', fontWeight: 900, color: themeColor, marginBottom: 10 }}>VAICKONS</h1>
                <p style={{ opacity: 0.2, fontSize: '1.5rem' }}>بواسطة يوسف محمد البلوشي</p>
              </div>
            )}
            {loading && <div style={{ color:themeColor, fontSize:'1rem', animate: 'pulse' }}>VAICKONS يفكر...</div>}
          </div>
        </div>

        <footer style={{ padding: '30px' }}>
          <div style={{ maxWidth:'900px', margin:'0 auto', display:'flex', background:'#0a0a0a', padding:'15px 25px', borderRadius:25, border:'1px solid #222', alignItems:'center', gap:15, boxShadow: '0 10px 30px rgba(0,0,0,0.5)' }}>
            <input value={input} onChange={e=>setInput(e.target.value)} onKeyPress={e=>e.key==='Enter' && handleSend()} placeholder="أرسل رسالة ليوسف البلوشي..." style={{ flex:1, background:'none', border:'none', color:'#fff', outline:'none', fontSize: '1.3rem', fontWeight: 'bold' }} />
            <Send onClick={handleSend} color={themeColor} cursor="pointer" size={30} />
          </div>
        </footer>
      </main>

      {/* نافذة الإعدادات الفخمة */}
      {showSettings && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.95)', zIndex: 2000, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 20 }}>
          <div style={{ background: '#080808', width: '100%', maxWidth: '950px', height: '700px', borderRadius: 35, border: '1px solid #222', display: 'flex', overflow: 'hidden' }}>
            <div style={{ width: '220px', background: '#050505', padding: '30px', borderRight: '1px solid #111' }}>
              {['عام', 'مظهر', 'أمان', 'مساعدة'].map(t => (
                <div key={t} onClick={() => setActiveTab(t)} style={{ padding: '15px', borderRadius: 15, cursor: 'pointer', background: activeTab === t ? '#111' : 'transparent', marginBottom: 10, fontWeight: 900, fontSize: '1.1rem', color: activeTab === t ? themeColor : '#fff' }}>{t}</div>
              ))}
            </div>
            <div style={{ flex: 1, padding: '50px', overflowY: 'auto' }}>
              <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:40}}>
                 <h2 style={{fontSize: '2rem'}}>إعدادات {activeTab}</h2>
                 <X onClick={()=>setShowSettings(false)} cursor="pointer" size={32}/>
              </div>
              
              {activeTab === 'عام' && <div style={{ display: 'flex', flexDirection: 'column', gap: 25 }}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}><span>لغة النظام (10 لغات)</span><select value={selectedLang} onChange={e=>setSelectedLang(e.target.value)} style={{background:'#000', color:'#fff', padding:10, borderRadius:10}}>{languages.map(l=><option key={l}>{l}</option>)}</select></div>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}><span>حجم الخط الرئيسي</span><input type="range" min="1" max="2" step="0.1" value={fontSize} onChange={e=>setFontSize(e.target.value)}/></div>
                {[...Array(18)].map((_, i) => <div key={i} style={{ display: 'flex', justifyContent: 'space-between', opacity: 0.2 }}><span>خيار ذكاء اصطناعي {i+3}</span><Zap size={18}/></div>)}
              </div>}

              {activeTab === 'مظهر' && <div style={{ display: 'flex', flexDirection: 'column', gap: 25 }}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}><span>لون الهوية الملكي</span><input type="color" value={themeColor} onChange={e=>setThemeColor(e.target.value)}/></div>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}><span>تفعيل النجوم المتحركة</span><input type="checkbox" checked={showStars} onChange={()=>setShowStars(!showStars)} style={{width:25, height:25}}/></div>
                {[...Array(18)].map((_, i) => <div key={i} style={{ display: 'flex', justifyContent: 'space-between', opacity: 0.2 }}><span>تخصيص جمالي {i+3}</span><Palette size={18}/></div>)}
              </div>}

              {activeTab === 'أمان' && <div style={{ display: 'flex', flexDirection: 'column', gap: 25 }}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}><span>تشفير بيانات يوسف البلوشي</span><Lock size={22} color={themeColor}/></div>
                {[...Array(19)].map((_, i) => <div key={i} style={{ display: 'flex', justifyContent: 'space-between', opacity: 0.2 }}><span>بروتوكول حماية {i+2}</span><Shield size={18}/></div>)}
              </div>}

              {activeTab === 'مساعدة' && <div>
                <p style={{fontSize: '1.3rem', marginBottom: 20}}>للدعم الفني المباشر تواصل مع المطور:</p>
                <div style={{ padding:30, borderRadius:20, background:'#111', border:`2px solid ${themeColor}`, display:'inline-block' }}>
                  <Mail size={24} style={{verticalAlign:'middle', marginRight:15}}/> <b style={{fontSize:'1.5rem'}}>vaickons1ai@gmail.com</b>
                </div>
                <div style={{marginTop:40, padding:20, borderLeft: `5px solid ${themeColor}`, background: '#0a0a0a'}}>
                   <p>هذا المشروع ملك للمطور <b>يوسف محمد البلوشي</b>. جميع الحقوق محفوظة 2026 ©</p>
                </div>
              </div>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}